// src/router/index.js
import Layout from '@/layout/Index.vue'
import Vue from "vue";
import Router from "vue-router";

// 引入页面组件
// import Register from "@/views/register.vue";
// import RegisterH5 from "@/views/register_h5.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: '',
      redirect: {
        name: 'home'
      },
      component: Layout,
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/home.vue'),
          meta: { title: '首页' },
        },
        {
          path: 'overview',
          name: 'overview',
          meta: { title: '公司概况' },
          component: () => import('@/views/overview.vue'),
        },
        {
          path: 'news',
          name: 'news',
          meta: { title: '资讯中心' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'work',
          name: 'work',
          meta: { title: '党群工作' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'window',
          name: 'window',
          meta: { title: '廉政之窗' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'talent',
          name: 'talent',
          meta: { title: '人才服务' },
          component: () => import('@/views/talent.vue'),
        },
        {
          path: 'library',
          name: 'library',
          meta: { title: '智库服务' },
          component: () => import('@/views/library.vue'),
        },
        // {
        //   path: 'notice',
        //   name: 'notice',
        //   meta: { title: '通知公告' },
        //   component: () => import('@/views/notice.vue'),
        // },
        {
          path: 'notice',
          name: 'notice',
          meta: { title: '通知公告' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'policy',
          name: 'policy',
          meta: { title: '政策法规' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'contact',
          name: 'contact',
          meta: { title: '联系我们' },
          component: () => import('@/views/contact.vue'),
        },
        {
          path: 'list',
          name: 'list',
          meta: { title: '' },
          component: () => import('@/views/list.vue'),
        },
        {
          path: 'childList',
          name: 'childList',
          meta: { title: '' },
          component: () => import('@/views/childList.vue'),
        },
        {
          path: 'detail',
          name: 'detail',
          meta: { title: '详情页' },
          component: () => import('@/views/detail.vue'),
        }
      ]
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
const routerPush = router.push;
router.push = path => {
  // 判断下当前路由是否就是要跳转的路由
  if (router.currentRoute.fullPath.includes(path)) return;
  return routerPush.call(router, path);
}
export default router;
